import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ExamsService } from '../exams.service';
import { LoginService } from '../login.service';
import { PatientsService } from '../patients.service';
import { SearchtextService } from '../searchtext.service';
import { SignatureService } from '../signature.service';

@Component({
    selector: 'app-searchtext',
    templateUrl: './searchtext.component.html',
    styleUrls: ['./searchtext.component.scss'],
    standalone: false
})
export class SearchtextComponent implements OnInit, OnDestroy {
  searchForm: UntypedFormGroup;

  exams;
  filterdExams =[];
  showLogin = false;
  startClinic
  goEx;
  showprint=false;
  showprintopts;//added by Hillel so that aot will work - maybe needs something else
  isLoading = false;
  sub = new Subscription()
  constructor(
    public fb: UntypedFormBuilder,
    public st: SearchtextService,
    public ls: LoginService,
    public ps: PatientsService,
    public es: ExamsService,
    public signatureService: SignatureService
  ) {}

  ngOnInit() {
    this.resetForm();
    this.sub = this.searchForm.get('text').valueChanges.pipe(debounceTime(1000)).subscribe((data) =>{
      this.searchText(data)
    })
  }
  
  resetForm(){
    this.searchForm = this.fb.group({
      text:['']
    })
  }
  searchText(text){
    this.isLoading = true;
    this.searchForm.get('text').disable({emitEvent:false})
    if(text != ''){
      var res = this.st.search(text)
      res.subscribe((data) => {
        this.exams = data[0]['data'];
      this.isLoading = false;
        this.searchForm.get('text').enable({emitEvent:false})
  
      })
    }else{
      this.exams =null;
      this.isLoading = false;
      this.searchForm.get('text').enable({emitEvent:false})
    }
  }

  goExam(exam/*PID: number, examID: number, PregIndex: number, etype: string,examtime: string*/) {
    let preg = exam.PregIndex ? { AutoIndex: exam.PregIndex } : null;
    let id = exam.AutoIndex;
    this.ps.getPatient(exam.PID, (s) => {
      if (s) {
        if (exam.Locked && exam.LockedBy && exam.LockedBy.toLowerCase() != this.ls.loginname.toLowerCase())
          return;
        let etime = new Date(exam.CreationTime);
        let now = new Date();
        if (exam.ExamType !== 'Emergency Room' && !this.signatureService.isExamSigned(exam) && (this.ls.userType === 'doctor' || this.ls.userType === 'visitingdoc' || this.ls.userType === 'tech')) {
          this.showLogin = true;

          this.goEx = { preg: preg, exam: exam, etype: exam.ExamType };
          if (this.ls.ClinicID)
            this.startClinic = this.ls.ClinicID;
        }
        else

          this.es.goExam(preg, exam, exam.ExamType, s.PID);
      }
    });
  }

  getLocked(exam) {
    var now = new Date();
    var lockedTime = new Date(exam.Locked);
    var lock = true;
    if (now.getDate() !=  lockedTime.getDate() ||  now.getMonth() != lockedTime.getMonth() || now.getFullYear() != lockedTime.getFullYear() || (now.getHours() - lockedTime.getHours()) > 1) {
     lock = false;
    }
    if ((exam.Locked || lock) && exam.LockedBy && exam.LockedBy.toLowerCase() != this.ls.loginname.toLowerCase())
      return 'locked';
    return 'unlocked';
  }

  filterData(){
    const NOKEY = ['PregCopied','NumFetuses','NaturalPregnancy','LastPrint','LastUpdate', 'CreationTime', 'Emergency','ExamType','ID']
    this.filterdExams = [];
    this.isLoading = true;
    if(!this.searchForm.get('text').value || this.searchForm.get('text').value == '')
      this.exams = null;
    if(this.exams){
      for(let exam of this.exams){
        var inExam = false
        for(var key of Object.keys(exam)){
          if(key.includes(this.searchForm.get('text').value) && ! NOKEY.includes(key)){
            inExam = true;
          }
        }
        if(inExam)
          this.filterdExams.push(exam)
      }
    }
    this.isLoading = false
  }
  viewonly() {
    this.es.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype, true);
  }
  ngOnDestroy(): void {
    this.sub.unsubscribe()
  }

}
